import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CLEAR_RESPONSE } from '../../stores/reducer_add'
import { useTranslation } from 'react-i18next';

const AddPopUp = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //取得全域store
    const add_response = useSelector(state => state.store_add_response || "");

    const [popupStatus, setPopupStatus] = useState(0); // 0: none, 1: show, 2: fade away, 3: hover
    const [addInfo, setAddInfo] = useState(0);

    useEffect(() => {
        //判斷是否真的有拿到回傳
        if (add_response.addResult.status !== "") {
            setPopupStatus(1);
        }
    }, [add_response])

    useEffect(() => {

        //清除內容
        if (popupStatus === 0) {
            dispatch(CLEAR_RESPONSE(true));
            return;
        }

        let countDown = null;

        //顯示三秒
        if (popupStatus === 1) {
            countDown = setTimeout(() => {
                setPopupStatus(2)
            }, 3000)
        }

        //消失1.5秒
        if (popupStatus === 2) {
            countDown = setTimeout(() => {
                setPopupStatus(0)
            }, 1500)
        }

        //停止
        if (popupStatus === 3) {
            return;
        }

        return () => { clearTimeout(countDown) }

    }, [popupStatus])

    // redux + 彈出提示
    function handleResponse(res) {
        let _text200, _text404, _text405, _text422, _textOther, _text500
        switch (res.type) {
            case "db_archive":
                _text200 = t('POP_UP.Backup_successful');
                _text422 = t('POP_UP.Backup_failed')
                _text404 = t('POP_UP.Backup_failed')
                _textOther = t('POP_UP.Backup_failed')
                break
            case "update_user":
                _text200 = t('POP_UP.Caregiver_update_successful');
                _text422 = t('POP_UP.Incomplete_information')
                _text404 = t('POP_UP.Update_failed')
                break
            case "update_user_pwd":
                _text200 = t('POP_UP.Password_update_successful');
                _text422 = t('POP_UP.Incomplete_information')
                _text404 = t('POP_UP.Update_failed')
                _textOther = t('POP_UP.No_password_change_entered')
                break
            case "create_user":
                _text200 = t('POP_UP.Caregiver_added_successfully');
                _text422 = t('POP_UP.Incomplete_information')
                _text404 = t('POP_UP.Caregiver_already_exists')
                break
            case "leave_hos":
                _text200 = t('POP_UP.Care_recipient_discharged');
                _text422 = t('POP_UP.Discharge_unsuccessful')
                _text404 = t('POP_UP.Care_recipient_not_found')
                break
            case "delete_user":
                _text200 = t('POP_UP.Caregiver_deleted_successfully');
                _text422 = t('POP_UP.Deletion_unsuccessful')
                _text404 = t('POP_UP.Caregiver_not_found')
                break
            case "duplicate_alert":
                _text200 = t('POP_UP.Duplicate_alert_setting_successful')
                _text422 = t('POP_UP.Setup_unsuccessful')
                _text404 = t('POP_UP.Setup_unsuccessful')
                break;
            case "sit_up_filter":
                _text200 = t('POP_UP.Agitation_filter_setting_successful')
                _text422 = t('POP_UP.Setup_unsuccessful')
                _text404 = t('POP_UP.Setup_unsuccessful')
                break;
            case "upadte_K":
                _text200 = t('POP_UP.K_value_setting_successful')
                _text422 = t('POP_UP.Setup_unsuccessful')
                _text404 = t('POP_UP.Setup_unsuccessful')
                break;
            case "create_resident":
                _text200 = t('POP_UP.Care_recipient_added_successfully');
                _text422 = t('POP_UP.Incomplete_information')
                _text404 = t('POP_UP.Care_recipient_already_exists')
                _text405 = t('POP_UP.Medical_record_number_already_exists')
                break;
            case "change_resident":
                _text200 = t('POP_UP.Care_recipient_change_successfully');
                _text422 = t('POP_UP.Incomplete_information')
                _text404 = t('POP_UP.Care_recipient_already_exists')
                _text405 = t('POP_UP.Medical_record_number_already_exists')
                break;
            case "update_resident":
                _text200 = t('POP_UP.Care_recipient_update_successful');
                _text422 = t('POP_UP.Setup_unsuccessful');
                _text404 = t('POP_UP.Setup_unsuccessful')
                break;
            case "delete_resident":
                _text200 = t('POP_UP.Care_recipient_deleted');
                _text422 = t('POP_UP.Deletion_unsuccessful');
                _text404 = t('POP_UP.Caregiver_not_found');
                break;
            case "delete_Institution":
                _text200 = t('POP_UP.Institution_deleted');
                _text422 = t('POP_UP.Deletion_unsuccessful');
                _text404 = t('POP_UP.Institution_not_found');
                break;
            case "create_Institution":
                _text200 = t('POP_UP.Institution_added');
                _text422 = t('POP_UP.Addition_unsuccessful')
                _text404 = t('POP_UP.Institution_already_exists')
                break;
            case "create_prodkey":
                _text200 = t('POP_UP.Key_added_successfully');
                _text422 = t('POP_UP.Key_addition_unsuccessful')
                _text404 = t('POP_UP.Key_already_exists')
                break;
            case "copy_uuid":
                _text200 = t('POP_UP.UUID_copied_successfully');
                _text422 = t('POP_UP.UUID_copy_unsuccessful')
                _text404 = t('POP_UP.UUID_copy_unsuccessful')
                break;
            case "input_email":
                _text200 = t('POP_UP.Email_format_verification_passed');
                _text422 = t('POP_UP.Email_not_filled_in')
                _text404 = t('POP_UP.Email_format_verification_error')
                break;
            case "input_tel":
                _text200 = t('POP_UP.Phone_format_verification_passed');
                _text422 = t('POP_UP.Phone_number_not_filled')
                _text404 = t('POP_UP.Phone_format_verification_error')
                break;
            case "password_authentication":
                _text200 = t('POP_UP.Password_verification_passed');
                _text422 = t('POP_UP.Password_not_filled')
                _text404 = t('POP_UP.Password_verification_failed')
                break;
            case "change_setting":
                _text200 = t('POP_UP.Setting_successful');
                _text422 = t('POP_UP.Setting_failed')
                _text404 = t('POP_UP.Setting_failed')
                break;
            case "alert_reply":
                _text200 = t('POP_UP.UART_program_restarted');
                _text422 = t('POP_UP.Program_restart_unsuccessful')
                _text404 = t('POP_UP.System_not_responding')
                break
            case "alert_reply_usb":
                _text200 = "";
                _text422 = t('POP_UP.USB_disconnected')
                _text404 = ""
                break
            case "dismiss_user":
                _text200 = t('POP_UP.Caregiver_logout_successful');
                _text422 = t('POP_UP.Logout_unsuccessful')
                _text404 = t('POP_UP.Caregiver_not_found')
                _textOther = t('POP_UP.Admin_account_cannot_logged_out')
                break
            case "dismiss_pad":
                _text200 = t('POP_UP.Unpairing_successful');
                _text422 = t('POP_UP.Unpairing_failed')
                _text404 = t('POP_UP.Pad_not_found')
                break
            case "alert_reply_Unpress":
                _text200 = "";
                _text422 = t('POP_UP.Right_side_of_mattress_not_pressed')
                _text404 = ""
                break
            case "wifi_setting":
                _text200 = t('POP_UP.Network_change_successful');
                _text422 = ""
                _text404 = ""
                break
            case "hisRec_no_data":
                _text200 = "";
                _text422 = t('POP_UP.Error')
                _text404 = t('POP_UP.No_current_data')
                break
            case "startat_time":
                _text200 = t('POP_UP.Shift_update_successful');
                _text422 = t('POP_UP.Shift_update_unsuccessful')
                _text404 = t('POP_UP.Shift_update_unsuccessful')
                break
            case "update_institution":
                _text200 = t('POP_UP.Unit_update_successful');
                _text422 = t('POP_UP.Unit_update_failed')
                _text404 = t('POP_UP.Smart_mattress_not_found')
                break
            case "update_bed_number":
                _text200 = t('POP_UP.Number_update_successful');
                _text422 = t('POP_UP.Number_update_failed')
                _text404 = t('POP_UP.Smart_mattress_not_found')
                break
            case "update_bed_name":
                _text200 = t('POP_UP.Bed_number_update_successful');
                _text422 = t('POP_UP.Bed_number_update_failed')
                _text404 = t('POP_UP.Smart_mattress_not_found')
                break
        }
        _text500 = t('POP_UP.Server_not_responding')
        if (res === null || res === undefined) { return }
        else if (res.status === 404) { return _text404 }
        else if (res.status === 405) { return _text405 }
        else if (res.status === 422) { return _text422 }
        else if (res.status === 666) { return _textOther }
        else if (res.status === null || res.status === undefined) { return _text500 }
        else return _text200
    }

    if (popupStatus === 0) {
        return null
    }
    return (
        <div className="animate_popup transition-ease-in pos-f z-2 wid-full hig-full right-0 bottom-0 fx-d-r fx-cfefe pt-none">
            <div className={`br-10 fx-d-c fx-ccc font-ml popout_response ${popupStatus === 2 ? "move" : ""} ${addInfo === 422 ? "info" : ""}`}
                onMouseEnter={() => { setPopupStatus(3) }}
                onMouseLeave={() => { setPopupStatus(1) }}
                onClick={e => e.stopPropagation()}>
                {handleResponse(add_response.addResult)}
                <div className='fx-d-c fx-ncfs'>
                    {addInfo === 422 ?
                        add_response.addResult.response.detail.map((item) => {
                            return (
                                <div key={item.loc[1]}>{item.loc[1]}</div>
                            )
                        }) : null
                    }
                </div>
            </div>
        </div>
    );
}
export default AddPopUp;